import { EngageFlatListItem } from 'types/Engage';

export type FlatIssue = {
  key: string;
  label: string;
  message: string;
  type?: 'owner' | 'resident';
};

export const getFlatIssues = (
  flat: Pick<EngageFlatListItem, 'isMissingResidents'>,
): FlatIssue[] => {
  const issues: FlatIssue[] = [];

  if (flat.isMissingResidents) {
    issues.push({
      key: 'missing-residents',
      label: 'Missing Resident Contacts',
      message: 'There may be other residents but their details aren’t recorded',
      type: 'resident',
    });
  }

  return issues;
};
